import { ChangeEvent } from "react";

export const numericNullableInputChangeHandler = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, inputCallback: (inp: string) => void, stateCallback: (inp: number | undefined) => void, errorClass = 'error') =>
{
    const value = parseFloat(event.currentTarget.value);
    const min = parseFloat(event.currentTarget.getAttribute('min')!);
    const max = parseFloat(event.currentTarget.getAttribute('max')!);
    const error = (value && (isNaN(value) || value < min || value > max));
    
    if(error)
    {
        event.currentTarget.classList.add(errorClass);
    }
    else 
    {
        event.currentTarget.classList.remove(errorClass);
    }

    if(!value)
    {
        inputCallback('');
        stateCallback(undefined);
    }
    else if(!isNaN(value))
    {
        inputCallback(value.toString());
        if(!error)
        {
            stateCallback(value);
        }
    }
}

export const numericInputChangeHandler = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, inputCallback: (inp: string) => void, stateCallback: (inp: number) => void, errorClass = 'error') =>
{
    const value = parseFloat(event.currentTarget.value);
    const min = parseFloat(event.currentTarget.getAttribute('min')!);
    const max = parseFloat(event.currentTarget.getAttribute('max')!);
    const error = (value && (isNaN(value) || value < min || value > max) || !value);
    
    if(error)
    {
        event.currentTarget.classList.add(errorClass);
    }
    else    
    {
        event.currentTarget.classList.remove(errorClass);
    }

    inputCallback(isNaN(value) ? event.currentTarget.value : value.toString());
    if(!isNaN(value))
    {
        if(!error)
        {
            stateCallback(value);
        }
    }
}